import { ButtonBase, styled } from '@mui/material';

export const OrangeChatButton = styled(ButtonBase)(({ theme }) => ({
  // Prevent media query conflicts
  '&': {
    ...theme.typography.button1n,
  },

  '--orange': '#FA8331',

  width: '100%',
  maxWidth: '320px',
  border: '2px solid',
  borderRadius: '99999px',
  padding: '10px 36px',
  backgroundColor: 'var(--orange)',
  borderColor: 'var(--orange)',
  color: 'white',
  transition: theme.transitions.create(['color', 'background-color']),
  textDecoration: 'none',

  '&:hover': {
    backgroundColor: 'white',
    borderColor: 'var(--orange)',
    color: 'var(--orange)',
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '400px',
    padding: '15px 36px',
  },
}));
